// extracted by mini-css-extract-plugin
module.exports = {"body":"PaginationTable_body__7Gi5L","toolbar":"PaginationTable_toolbar__1u4zl","table":"PaginationTable_table__2Byi3","actions":"PaginationTable_actions__3ayFw"};